module.exports = __webpack_public_path__ + "img/new.28b692ea.png";